<template>
  <BCard no-body class="w-100 h-100">
    <BCardBody class="p-0">
      <div class="image-container">
        <a :href="`${baseURL}/portfolio-review-pro`" target="_blank">
          <img
            v-if="isMobile"
            :src="mainImageMobile"
            alt="Mobile Image"
            class="main-image"
          />
          <img v-else :src="mainImage" alt="Web Image" class="main-image" />
        </a>
      </div>
    </BCardBody>
  </BCard>
</template>

<script>
export default {
  name: "subPrp",
  data() {
    return {
      mainImage: require("@/assets/images/portfolio/Dashboardwebsubscriberbanner.svg"),
      mainImageMobile: require("@/assets/images/portfolio/mainMobile.svg"),
      isMobile: window.innerWidth <= 768,
      baseURL: process.env.VUE_APP_BASE_URL,
    };
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.isMobile = window.innerWidth <= 768;
    },
  },
};
</script>

<style scoped>
.image-container {
  height: 100%;
}

.main-image {
  width: 100%;
  height: 102%;
  object-fit: cover;
  display: block;
  border-radius: 5px;
}
</style>
